import { JobsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { jobsKeys } from 'app/queries/jobs/jobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.repositoryList>>;

export const createFetchRepositoryJobsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ repositoryId, params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        JobsService.getRepoJobs({
          repositoryId,
          pageNo: String(params.page),
          pageSize: String(params.pageSize),
          orderBy: params.orderBy,
          orderType: params.orderType,
          search: params.search,
        }),
        signal,
      ),
    );
